import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import usePetsList from '../../hooks/usePetsList';
import DonateHome from '../../components/DonateHome';
import Hero from '../../components/Hero';
import Footer from '../../components/Footer';
import PetItem from '../../components/PetItem';
import AboutHome from '../../components/AboutHome';
import Sponsor from '../../components/Sponsor';
import Preloader from '../../components/Preloader';
// TODO: when on mobile changing between pages doesnt move to top
function Home() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 }); // Optional config
  }, []);

  const { data: pets, isLoading } = usePetsList();
  return (
    <div id="top">
      {isLoading && <Preloader />}

      <Hero />
      <section id="adopt" className="paws-house-bg1 bg-light">
        <div className="container ">
          <div className="section-heading text-center">
            <h2>{t('adoptionPage.adopt_pet')}</h2>
          </div>
          {/* /Section-heading */}
          {/* <div className="col-lg-10 offset-lg-1 text-center">
            <h4>{t('adoptionPage.intro')}</h4>
          </div> */}

          <div className="row mt-5">
            {pets?.slice(0, 4).map(pet => (
              <div key={pet?._id} className="col-md-6 col-xl-3 res-margin d-flex align-items-stretch mb-4">
                <PetItem pet={pet} />
              </div>
            ))}
          </div>
          {/* /row */}
          <div className="text-center mt-5">
            <Link className="btn btn-secondary btn-lg" to={i18n.language === 'bs' ? '/adoption' : `/${i18n.language}/adoption`}>
              {t('homePage.see_all_pets')}
            </Link>
          </div>
        </div>
        {/* /container */}
      </section>
      <DonateHome />
      <section className="dog-bg3 bg-light-custom block-padding">
        <Sponsor />
      </section>
      <AboutHome />
      {/* <Blurb /> */}
      {/* <GalleryHome /> */}
      {/* <Team /> */}
      {/* Section Call to action */}
      <div id="call-to-action">
        <div className="container block-padding">
          <div className="col-lg-6 offset-lg-6 bg-primary text-light card text-center">
            <h4 style={{ marginBottom: '15px', fontWeight: '600' }}>
              {t('homePage.follow_us_on_social_media')}
            </h4>
            <p style={{ margin: '5px 0' }}>
              Instagram:{' '}
              <a
                href="https://www.instagram.com/pawfriends_sarajevo/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#F9BE4F', fontWeight: '500' }}
              >
                @pawfriends_sarajevo
              </a>
            </p>
            <p style={{ margin: '5px 0' }}>
              {t('common.facebook_page')}:{' '}
              <a
                href="https://www.facebook.com/pawfriendssarajevo"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#F9BE4F', fontWeight: '500' }}
              >
                PawFriends Sarajevo
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
